import styled from 'styled-components';
import theme from 'theme';

export const ActionLink = styled.a`
  font-size: 12px;
  color: ${theme.colors.colorRoyalBlue};
  cursor: pointer;
`;
